var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmployerInvite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3121 9.288L13.6697 8.64556L14.7875 7.52658L13.1237 5.86284L12.0035 6.98417L11.3622 6.35585L15.3664 2.3459L18.3057 5.27806L14.3121 9.288ZM9.942 13.6415L5.9484 17.6515L2.99852 14.7193L7.0027 10.7094L7.64045 11.3471L6.49438 12.492L8.15818 14.1557L9.30542 13.0097L9.942 13.6415V13.6415ZM19.9695 3.6202L17.0208 0.671581C16.0983 -0.227371 14.6122 -0.22385 13.7085 0.682166L9.69843 4.69209C8.78651 5.60515 8.78651 7.08888 9.69843 8.00195L10.3409 8.64556L9.30424 9.68217L8.67591 9.05503C8.23702 8.60555 7.65103 8.35611 7.02387 8.35258H7.00975C6.3826 8.35258 5.79191 8.5985 5.34477 9.04444L1.33472 13.0556C0.421631 13.9686 0.421631 15.4523 1.33472 16.3654L4.28459 19.3152C4.74115 19.7717 5.34007 20 5.94016 20C6.53908 20 7.13918 19.7717 7.59572 19.3152L11.6058 15.3053C12.0564 14.8546 12.3024 14.2581 12.2988 13.6262C12.2941 12.9991 12.0447 12.4131 11.6058 11.9836L10.968 11.3471L12.0058 10.3093L12.6483 10.9529C13.1048 11.4083 13.7038 11.6365 14.3039 11.6365C14.9028 11.6365 15.5029 11.4083 15.9583 10.9517L19.9695 6.9418C20.8743 6.03697 20.8791 4.55089 19.9695 3.62018L19.9695 3.6202Z",
    fill: "#00406A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployerInvite);
export default __webpack_public_path__ + "static/media/employerInvite.8f41e17b1e55c60c198461e9982ce2a9.svg";
export { ForwardRef as ReactComponent };